const s = {
  name: "Lock",
  dimensions: { width: 30, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 30 40" style="enable-background:new 0 0 30 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13.8,20.1c1.5-0.4,3.1,0,4.3,0.9l0,0c1.2,1,1.9,2.4,1.9,3.9c0,1.6-0.8,3-2,4v2c0,1.6-1.4,3-3,3
			c-1.7,0-3-1.4-3-3v-2c-1.6-1.2-2.3-3.2-1.9-5.2C10.6,22,12,20.5,13.8,20.1z M16,27.9l0.5-0.3v0C17.4,27,18,26.1,18,25
			c0-0.9-0.4-1.8-1.1-2.4C16.3,22.2,15.7,22,15,22c-0.2,0-0.5,0-0.7,0.1c-1,0.2-1.9,1.1-2.2,2.1c-0.3,1.4,0.2,2.7,1.4,3.4l0.5,0.3
			V31c0,0.6,0.4,1,1,1s1-0.4,1-1V27.9z"/>
		<path class="st0" d="M24,9v3h6v28H0V12h6V9c0-5,4-9,9-9S24,4,24,9z M15,2c-3.9,0-7,3.1-7,7v3h14V9C22,5.1,18.9,2,15,2z M2,14v24
			h26V14H2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Lock
};
